import { render, staticRenderFns } from "./DocsLayout.vue?vue&type=template&id=7d4fdb5e&"
import script from "./DocsLayout.vue?vue&type=script&lang=js&"
export * from "./DocsLayout.vue?vue&type=script&lang=js&"
import style0 from "./DocsLayout.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports